import axios from 'axios';

export const axiosBaseQuery =
  () =>
  async ({ url, method = 'GET', data, params, headers }) => {
    try {
      const result = await axios({ url, method, data, params, headers });
      return { data: result.data };
    } catch (error) {
      return {
        error: {
          status: error.response?.status,
          data: error.response?.data,
          originalError: error,
        },
      };
    }
  };
